import { render } from "./AddProduit.vue?vue&type=template&id=2cbf8d7b&scoped=true&ts=true"
import script from "./AddProduit.vue?vue&type=script&lang=ts"
export * from "./AddProduit.vue?vue&type=script&lang=ts"

import "./AddProduit.vue?vue&type=style&index=0&id=2cbf8d7b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cbf8d7b"]])

export default __exports__